import { CreateSyncTranslateTaskApi } from '@/infrastructure/api-functions/core-drafting-api/create-sync-translate-task-api';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@telecom/shared/services/i18n';
import { RavenService } from '@telecom/shared/services/raven-service/raven-service';
import type { TranslateOptions } from '../../types';
import type { CreateSyncTranslateTaskService } from '../create-sync-translate-task-service';

@injectable()
export class CreateSyncTranslateTaskServiceImpl implements CreateSyncTranslateTaskService {
    constructor(
        @inject(CreateSyncTranslateTaskApi)
        private readonly _createSyncTranslateTaskApi: CreateSyncTranslateTaskApi,
        @inject(I18nService)
        private readonly _i18nService: I18nService,
        @inject(RavenService)
        private readonly _ravenService: RavenService,
    ) {}

    createTranslateTask(taskId: string, translateOptions: TranslateOptions): Promise<void> {
        console.info('创建同步翻译任务', taskId, translateOptions);
        return this._createTaskRepository(taskId, translateOptions);
    }

    private _createTaskRepository(taskId: string, translateOptions: TranslateOptions) {
        return this._createSyncTranslateTaskApi.createSyncTranslateTask({
            task_id: taskId,
            type: 'AI_TRANSLATION',
            content: {
                source_lang: translateOptions.sourceLanguage!,
                target_lang: translateOptions.targetLanguage,
                user_input: translateOptions.text,
            },
        });
    }
}
